module.exports = "/_next/static/images/aefe259f3556998b5d1cda7016ae10b6-complexity@lg-2x.jpg";